import React from 'react';
import {
  HashimotoTestInputType,
  withLoading,
  useTranslator,
} from '@front-activerse/common-components';
import { Container, Row, Col } from 'reactstrap';
import Layout from '../../Layout/Layout';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import TestsForm from './TestsForm';
import TitleBar from '../../Layout/TitleBar';

interface ITestsAddContainer {
  addTestMeasurement: {
    addTest: (request: HashimotoTestInputType) => Promise<any>;
  };
}

const TestsAddContainer: React.FC<ITestsAddContainer> = ({ addTestMeasurement }) => {
  const { t } = useTranslator();
  return (
    <Layout>
      <div className="page-template-lab-tests full-height2">
        <TitleBar>{t('addTestResults.navbarTitle')}</TitleBar>
        <section className="page-template-lab-tests">
          <Container className="py-md-4">
            <Row>
              <Col md={{ size: 10, offset: 1 }}>
                <div className="page-container">
                  <div className="lab-tests-container">
                    <Row>
                      <Col xl={{ size: 6, offset: 3 }}>
                        <TestsForm addTestMeasurement={addTestMeasurement} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
};

const Placeholder = <UniversalPlaceholder titleBar="" />;

export default withLoading(TestsAddContainer, Placeholder);
